<template>
    <div data-testid="count-actions" class="count-actions">
        <div class="d-flex mb-4">
            <CountSection :count="data.length"
                :networkLabel="$nova.labelsName('gl_selection', 'division_label', 'Network')"
                :countLabel="$nova.labelsName('gl_selection', 'commentary_count_label', 'Count')" />

            <v-spacer></v-spacer>

            <CountToolbar :pendingRequestCount="pendingRequestList.length" @get-pending-requests="getPendingRequests"
                @show-faq="showFAQ" @refresh="refreshData" />
        </div>
    </div>
</template>

<script>
import CountSection from './CountSection.vue';
import CountToolbar from './CountToolbar.vue';

export default {
    name: 'CountActions',
    components: {
        CountSection,
        CountToolbar
    },
    data() {
        return {
        }
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        pendingRequestList: {
            type: Array,
            required: true
        }

    },
    methods: {
        getPendingRequests() {
            this.$emit('get-pending-requests');
        },
        showFAQ() {
            this.$emit('showFAQ-dialog')
        },
        refreshData() {
            this.$emit('refresh-data')
        }
    }
}
</script>

<style scoped></style>